<script setup>
import { useObterTotalAcordosNoMesPorResponsavel } from '~/composables/pastas/useObterTotalAcordosNoMesPorResponsavel';
import { onMounted, computed } from 'vue';
import { colors } from '~/utils';

const {
  status: obterTotalAcordosNoMesPorResponsavelStatus,
  data: obterTotalAcordosNoMesPorResponsavelData,
  runAsync: obterTotalAcordosNoMesPorResponsavelAsync,
} = useObterTotalAcordosNoMesPorResponsavel();

const chartOptions = computed(() => {
  if (obterTotalAcordosNoMesPorResponsavelStatus.value !== 'success') {
    return null;
  }
  return {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    series: [
      {
        name: 'total de acordos',
        data: obterTotalAcordosNoMesPorResponsavelData.value.items.map(
          (x) => x.total
        ),
      },
    ],
    xaxis: {
      categories: obterTotalAcordosNoMesPorResponsavelData.value.items.map(
        (x) => x.label.toUpperCase()
      ),
      labels: {
        show: false,
      },
    },
  };
});

onMounted(async () => {
  await obterTotalAcordosNoMesPorResponsavelAsync();
});
</script>

<template>
  <ChartCard
    :status="obterTotalAcordosNoMesPorResponsavelStatus"
    :options="chartOptions"
  >
    <template #title>
      <span style="color: rgb(128 128 128); font-size: 16px"
        >TOTAL DE ACORDOS NO MÊS POR RESPONSÁVEL</span
      >
    </template>
  </ChartCard>
</template>
